import classnames from 'classnames'
import Button from './Button'
import FloatingModal from './modals/FloatingModal'

type ConfirmDialogProps = {
  title: string
  message: string | string[]
  onConfirm: () => void
  onCancel: () => void
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  isDestructiveAction?: boolean
  confirmButtonLabel?: string
  cancelButtonLabel?: string
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  title = 'Are you sure?',
  message = 'Are you sure you want to do this?',
  confirmButtonLabel = 'Confirm',
  cancelButtonLabel = 'Cancel',
  onConfirm,
  onCancel,
  isOpen,
  setIsOpen,
  isDestructiveAction = false,
}) => {
  const handleConfirm = () => {
    onConfirm()
    setIsOpen(false)
  }

  const handleCancel = () => {
    onCancel()
    setIsOpen(false)
  }

  const primaryButtonClassnames = classnames(
    'btn',
    {
      'btn--danger': isDestructiveAction,
      'btn--primary': !isDestructiveAction,
    },
    'qa-confirm-button'
  )
  const secondaryButtonClassnames = 'btn btn--secondary qa-cancel-button'

  const messagesContent = Array.isArray(message) ? message.map((msg, i) => <p key={i}>{msg}</p>) : <p>{message}</p>
  return (
    <FloatingModal title={title} show={isOpen} onClose={handleCancel}>
      <div className="dialog qa-confirm-dialog">
        {messagesContent}
        <div className="actions">
          <Button className={secondaryButtonClassnames} onClick={handleCancel} aria-label="Cancel">
            {cancelButtonLabel}
          </Button>
          <Button className={primaryButtonClassnames} onClick={handleConfirm} aria-label="Confirm">
            {confirmButtonLabel}
          </Button>
        </div>
      </div>
    </FloatingModal>
  )
}

export default ConfirmDialog
